var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    _vm.$style.container,
    _vm.pageIsMenu && _vm.$style.containerMenu,
    _vm.active && _vm.$style.containerActive,
  ]},[_c('icon',{attrs:{"name":_vm.icon,"width":"18","height":"18"}}),_c('div',{class:_vm.$style.label},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }